import ResponsiveImage from '~/components/Image/ResponsiveImage'

export default function BgPattern({ className = '' }: { className?: string }): React.ReactElement {
  return (
    <div className={`absolute top-0 left-0 right-0 bottom-0 w-screen h-full opacity-5 overflow-hidden ${className}`}>
      <ResponsiveImage
        height={800}
        imageClassName="min-w-screen w-full h-full object-cover"
        srcKey="landing/bg-pattern.png"
        width={1600}
      />
    </div>
  )
}
